module.exports = __webpack_public_path__ + "static/Background-voter-1.2dc794d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-voter-1.jpg
// module id = 478
// module chunks = 265584890008614